import { render, staticRenderFns } from "./_purgeSBOMatchLog.vue?vue&type=template&id=5c0848f0&scoped=true&lang=pug&"
import script from "./_purgeSBOMatchLog.vue?vue&type=script&lang=js&"
export * from "./_purgeSBOMatchLog.vue?vue&type=script&lang=js&"
import style0 from "./_purgeSBOMatchLog.vue?vue&type=style&index=0&id=5c0848f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0848f0",
  null
  
)

export default component.exports